export default {"src":"/_next/static/media/bi.20886b46.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};